import './styles/main.scss';

import { h } from 'preact';
import { hydrate, prerender as ssr } from 'preact-iso';
import App from './scripts/App';
import { routes } from './data/prerenderUrls';

if (typeof window !== 'undefined') {
    hydrate(<App />, document.getElementById('app'));
}

function getHeadElements(url) {
    const route = routes.find((r) => r.url === url);
    if (!route) {
        return {};
    }
    return {
        title: route.title,
        elements: new Set([
            {
                type: 'link',
                props: {
                    rel: 'canonical',
                    href: `${import.meta.env.HUGO_CLIENT_URL}${route.url}`,
                },
            },
            { type: 'meta', props: { property: 'description', content: route.description } },
        ]),
    };
}

export async function prerender(data) {
    const { html, links } = await ssr(<App {...data} />);
    return {
        html,
        links,
        head: { ...getHeadElements(data.url) },
    };
}
